export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10117.8db5c194.jpg";